// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JI0sJueM65ZLXC05xkCV {
  display: grid;
  align-items: center;
}

@media (max-width: 1100px) {
  .JI0sJueM65ZLXC05xkCV {
    grid-template: repeat(5, auto) / 1fr 8fr 8fr 1fr;
    gap: 10px;
    grid-template-areas:
      'a b b c'
      'e e e e'
      'd d d d'
      'f f f f'
      'g g g g';
  }

  .bNFjwUdec5K3Gqi_NXvH,
  .ZsS5voqUVK71CbP4cqmr {
    width: 50%;
  }

  .unF_rkU5wVv4ktGaheCo {
    width: 100%;
  }

  .ZsS5voqUVK71CbP4cqmr {
    text-align: center;
  }

  .ytzNnmlPRyp2Ufl0S1bS > div {
    flex-wrap: wrap;
  }

  .cQa8_k0F8EYObVJ3YBzf {
    margin: 10px 7px;
  }

  .ordMG8e8gb1NtRh8p4JA {
    display: flex;
    flex-wrap: nowrap;
    gap: 10px;
  }

  .ordMG8e8gb1NtRh8p4JA > * {
    flex-grow: 1;
  }
}

@media (max-width: 600px) {
  .JI0sJueM65ZLXC05xkCV {
    grid-template: repeat(6, auto) / 1fr 1fr;
    grid-template-areas:
      'b b'
      'a c'
      'e e'
      'd d'
      'f f'
      'g g';
  }

  .cQa8_k0F8EYObVJ3YBzf {
    margin: 10px 7px;
  }
}

@media (min-width: 1101px) {
  .JI0sJueM65ZLXC05xkCV {
    grid-template: repeat(4, auto) / 1fr 1fr 1fr 1fr;
    gap: 5px;
    grid-template-areas:
      'a b b c'
      'e e e e'
      'd d f f'
      'g g g g';
  }

  .ordMG8e8gb1NtRh8p4JA {
    display: flex;
    justify-content: end;
    gap: 10px;
  }

  .ZsS5voqUVK71CbP4cqmr {
    min-width: 150px;
  }

  .unF_rkU5wVv4ktGaheCo {
    max-width: 350px;
  }

  .cQa8_k0F8EYObVJ3YBzf {
    margin: 10px 9px;
  }
}

.JI0sJueM65ZLXC05xkCV > * {
  min-width: 0;
  min-height: 0;
}

.d__gLC38cDx55GXQ4vv8 {
  grid-area: a;
}
.LqfcuJTb2fifdYC0GcQ5 {
  grid-area: b;
}
.tNFei351X39KljFI1isr {
  grid-area: c;
}
.unF_rkU5wVv4ktGaheCo {
  grid-area: d;
}
.ytzNnmlPRyp2Ufl0S1bS {
  grid-area: e;
}
.ordMG8e8gb1NtRh8p4JA {
  grid-area: f;
}
.w_2iIT10GercsyPiox_H {
  grid-area: g;
}

.Wej6M5UqNtnOq2UE0oIn {
  text-align: center;
}

input[type='text'].xYeEPdG3bF4uviyxkHme {
  background-color: transparent !important;
  color: var(--chapito-color-action) !important;
}
`, "",{"version":3,"sources":["webpack://./web/static/pages/home.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,gDAAgD;IAChD,SAAS;IACT;;;;;eAKW;EACb;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,wCAAwC;IACxC;;;;;;WAMO;EACT;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gDAAgD;IAChD,QAAQ;IACR;;;;eAIW;EACb;;EAEA;IACE,aAAa;IACb,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,6CAA6C;AAC/C","sourcesContent":[".header {\n  display: grid;\n  align-items: center;\n}\n\n@media (max-width: 1100px) {\n  .header {\n    grid-template: repeat(5, auto) / 1fr 8fr 8fr 1fr;\n    gap: 10px;\n    grid-template-areas:\n      'a b b c'\n      'e e e e'\n      'd d d d'\n      'f f f f'\n      'g g g g';\n  }\n\n  .filtersToggleButton,\n  .sortOrderDropdown {\n    width: 50%;\n  }\n\n  .searchInput {\n    width: 100%;\n  }\n\n  .sortOrderDropdown {\n    text-align: center;\n  }\n\n  .daySelector > div {\n    flex-wrap: wrap;\n  }\n\n  .daySelectorBtn {\n    margin: 10px 7px;\n  }\n\n  .buttonsBox {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 10px;\n  }\n\n  .buttonsBox > * {\n    flex-grow: 1;\n  }\n}\n\n@media (max-width: 600px) {\n  .header {\n    grid-template: repeat(6, auto) / 1fr 1fr;\n    grid-template-areas:\n      'b b'\n      'a c'\n      'e e'\n      'd d'\n      'f f'\n      'g g';\n  }\n\n  .daySelectorBtn {\n    margin: 10px 7px;\n  }\n}\n\n@media (min-width: 1101px) {\n  .header {\n    grid-template: repeat(4, auto) / 1fr 1fr 1fr 1fr;\n    gap: 5px;\n    grid-template-areas:\n      'a b b c'\n      'e e e e'\n      'd d f f'\n      'g g g g';\n  }\n\n  .buttonsBox {\n    display: flex;\n    justify-content: end;\n    gap: 10px;\n  }\n\n  .sortOrderDropdown {\n    min-width: 150px;\n  }\n\n  .searchInput {\n    max-width: 350px;\n  }\n\n  .daySelectorBtn {\n    margin: 10px 9px;\n  }\n}\n\n.header > * {\n  min-width: 0;\n  min-height: 0;\n}\n\n.viewSwitchDropDown {\n  grid-area: a;\n}\n.title {\n  grid-area: b;\n}\n.langSwitchDropdown {\n  grid-area: c;\n}\n.searchInput {\n  grid-area: d;\n}\n.daySelector {\n  grid-area: e;\n}\n.buttonsBox {\n  grid-area: f;\n}\n.shortcutFiltersContainer {\n  grid-area: g;\n}\n\n.shortcutFilterDropdown {\n  text-align: center;\n}\n\ninput[type='text'].filterInputTextInput {\n  background-color: transparent !important;\n  color: var(--chapito-color-action) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `JI0sJueM65ZLXC05xkCV`,
	"filtersToggleButton": `bNFjwUdec5K3Gqi_NXvH`,
	"sortOrderDropdown": `ZsS5voqUVK71CbP4cqmr`,
	"searchInput": `unF_rkU5wVv4ktGaheCo`,
	"daySelector": `ytzNnmlPRyp2Ufl0S1bS`,
	"daySelectorBtn": `cQa8_k0F8EYObVJ3YBzf`,
	"buttonsBox": `ordMG8e8gb1NtRh8p4JA`,
	"viewSwitchDropDown": `d__gLC38cDx55GXQ4vv8`,
	"title": `LqfcuJTb2fifdYC0GcQ5`,
	"langSwitchDropdown": `tNFei351X39KljFI1isr`,
	"shortcutFiltersContainer": `w_2iIT10GercsyPiox_H`,
	"shortcutFilterDropdown": `Wej6M5UqNtnOq2UE0oIn`,
	"filterInputTextInput": `xYeEPdG3bF4uviyxkHme`
};
export default ___CSS_LOADER_EXPORT___;
